export const data = [
  {
    y: 100,
    marker: {
      enabled: false,
      radius: 5,
    },
  },
  {
    y: 94.249,
    marker: {
      enabled: false,
    },
  },
  {
    y: 96.979,
    marker: {
      enabled: false,
    },
  },
  {
    y: 97.075,
    marker: {
      enabled: false,
    },
  },
  {
    y: 87.8,
    marker: {
      enabled: false,
    },
  },
  {
    y: 82.06,
    marker: {
      enabled: false,
    },
  },
  {
    y: 79.837,
    marker: {
      enabled: false,
    },
  },
  {
    y: 84.585,
    marker: {
      enabled: false,
    },
  },
  {
    y: 87.175,
    marker: {
      enabled: false,
    },
  },
  {
    y: 89.788,
    marker: {
      enabled: false,
    },
  },
  {
    y: 88.264,
    marker: {
      enabled: false,
    },
  },
  {
    y: 90.035,
    marker: {
      enabled: false,
    },
  },
  {
    y: 94.292,
    marker: {
      enabled: false,
    },
  },
  {
    y: 98.42,
    marker: {
      enabled: false,
    },
  },
  {
    y: 99.255,
    marker: {
      enabled: false,
    },
  },
  {
    y: 103.407,
    marker: {
      enabled: false,
    },
  },
  {
    y: 106.587,
    marker: {
      enabled: false,
    },
  },
  {
    y: 103.859,
    marker: {
      enabled: false,
    },
  },
  {
    y: 104.711,
    marker: {
      enabled: false,
    },
  },
  {
    y: 102.836,
    marker: {
      enabled: false,
    },
  },
  {
    y: 104.877,
    marker: {
      enabled: false,
    },
  },
  {
    y: 103.676,
    marker: {
      enabled: false,
    },
  },
  {
    y: 99.54,
    marker: {
      enabled: false,
    },
  },
  {
    y: 100.176,
    marker: {
      enabled: false,
    },
  },
  {
    y: 108.993,
    marker: {
      enabled: false,
    },
  },
  {
    y: 112.774,
    marker: {
      enabled: false,
    },
  },
  {
    y: 116.888,
    marker: {
      enabled: false,
    },
  },
  {
    y: 118.297,
    marker: {
      enabled: false,
    },
  },
  {
    y: 119.654,
    marker: {
      enabled: false,
    },
  },
  {
    y: 121.882,
    marker: {
      enabled: false,
    },
  },
  {
    y: 118.841,
    marker: {
      enabled: false,
    },
  },
  {
    y: 120.466,
    marker: {
      enabled: false,
    },
  },
  {
    y: 123.678,
    marker: {
      enabled: true,
    },
  },
  {
    y: 121.59,
    marker: {
      enabled: false,
    },
  },
  {
    y: 122.381,
    marker: {
      enabled: false,
    },
  },
  {
    y: 128.591,
    marker: {
      enabled: false,
    },
  },
  {
    y: 130.737,
    marker: {
      enabled: false,
    },
  },
  {
    y: 130.825,
    marker: {
      enabled: false,
    },
  },
  {
    y: 131.515,
    marker: {
      enabled: false,
    },
  },
  {
    y: 131.476,
    marker: {
      enabled: false,
    },
  },
  {
    y: 124.631,
    marker: {
      enabled: false,
    },
  },
  {
    y: 124.046,
    marker: {
      enabled: false,
    },
  },
  {
    y: 124.611,
    marker: {
      enabled: false,
    },
  },
  {
    y: 127.351,
    marker: {
      enabled: false,
    },
  },
  {
    y: 121.822,
    marker: {
      enabled: false,
    },
  },
  {
    y: 125.11,
    marker: {
      enabled: false,
    },
  },
  {
    y: 126.136,
    marker: {
      enabled: false,
    },
  },
  {
    y: 109.548,
    marker: {
      enabled: false,
    },
  },
  {
    y: 108.41,
    marker: {
      enabled: false,
    },
  },
  {
    y: 109.006,
    marker: {
      enabled: false,
    },
  },
  {
    y: 110.459,
    marker: {
      enabled: false,
    },
  },
  {
    y: 107.416,
    marker: {
      enabled: false,
    },
  },
  {
    y: 105.382,
    marker: {
      enabled: false,
    },
  },
  {
    y: 100.892,
    marker: {
      enabled: false,
    },
  },
  {
    y: 97.476,
    marker: {
      enabled: false,
    },
  },
  {
    y: 91.462,
    marker: {
      enabled: false,
    },
  },
  {
    y: 82.39,
    marker: {
      enabled: false,
    },
  },
  {
    y: 74.454,
    marker: {
      enabled: false,
    },
  },
  {
    y: 81.329,
    marker: {
      enabled: false,
    },
  },
  {
    y: 79.808,
    marker: {
      enabled: false,
    },
  },
  {
    y: 78.237,
    marker: {
      enabled: false,
    },
  },
  {
    y: 89.398,
    marker: {
      enabled: false,
    },
  },
  {
    y: 97.047,
    marker: {
      enabled: false,
    },
  },
  {
    y: 97.51,
    marker: {
      enabled: false,
    },
  },
  {
    y: 101.3,
    marker: {
      enabled: false,
    },
  },
  {
    y: 103.447,
    marker: {
      enabled: false,
    },
  },
  {
    y: 104.505,
    marker: {
      enabled: false,
    },
  },
  {
    y: 98.483,
    marker: {
      enabled: false,
    },
  },
  {
    y: 96.723,
    marker: {
      enabled: false,
    },
  },
  {
    y: 92.428,
    marker: {
      enabled: false,
    },
  },
  {
    y: 98.555,
    marker: {
      enabled: false,
    },
  },
  {
    y: 101.013,
    marker: {
      enabled: false,
    },
  },
  {
    y: 100.863,
    marker: {
      enabled: false,
    },
  },
  {
    y: 109.636,
    marker: {
      enabled: false,
    },
  },
  {
    y: 108.582,
    marker: {
      enabled: false,
    },
  },
  {
    y: 109.621,
    marker: {
      enabled: false,
    },
  },
  {
    y: 108.579,
    marker: {
      enabled: false,
    },
  },
  {
    y: 106.525,
    marker: {
      enabled: false,
    },
  },
  {
    y: 109.559,
    marker: {
      enabled: false,
    },
  },
  {
    y: 108.288,
    marker: {
      enabled: false,
    },
  },
  {
    y: 107.791,
    marker: {
      enabled: false,
    },
  },
  {
    y: 108.443,
    marker: {
      enabled: false,
    },
  },
  {
    y: 104.395,
    marker: {
      enabled: false,
    },
  },
  {
    y: 103.725,
    marker: {
      enabled: false,
    },
  },
  {
    y: 111.262,
    marker: {
      enabled: false,
    },
  },
  {
    y: 107.261,
    marker: {
      enabled: false,
    },
  },
  {
    y: 106.52,
    marker: {
      enabled: false,
    },
  },
  {
    y: 105.581,
    marker: {
      enabled: false,
    },
  },
  {
    y: 106.46,
    marker: {
      enabled: false,
    },
  },
  {
    y: 104.734,
    marker: {
      enabled: false,
    },
  },
  {
    y: 108.395,
    marker: {
      enabled: false,
    },
  },
  {
    y: 106.659,
    marker: {
      enabled: false,
    },
  },
  {
    y: 106.77,
    marker: {
      enabled: false,
    },
  },
  {
    y: 107.812,
    marker: {
      enabled: false,
    },
  },
  {
    y: 105.68,
    marker: {
      enabled: false,
    },
  },
  {
    y: 106.709,
    marker: {
      enabled: false,
    },
  },
  {
    y: 108.521,
    marker: {
      enabled: false,
    },
  },
  {
    y: 105.02,
    marker: {
      enabled: false,
    },
  },
  {
    y: 103.901,
    marker: {
      enabled: false,
    },
  },
  {
    y: 108.282,
    marker: {
      enabled: false,
    },
  },
  {
    y: 112.831,
    marker: {
      enabled: false,
    },
  },
  {
    y: 113.929,
    marker: {
      enabled: false,
    },
  },
  {
    y: 114.736,
    marker: {
      enabled: false,
    },
  },
  {
    y: 122.678,
    marker: {
      enabled: false,
    },
  },
  {
    y: 125.16,
    marker: {
      enabled: false,
    },
  },
  {
    y: 126.266,
    marker: {
      enabled: false,
    },
  },
  {
    y: 123.462,
    marker: {
      enabled: false,
    },
  },
  {
    y: 118.757,
    marker: {
      enabled: false,
    },
  },
  {
    y: 122.28,
    marker: {
      enabled: false,
    },
  },
  {
    y: 125.06,
    marker: {
      enabled: false,
    },
  },
  {
    y: 122.353,
    marker: {
      enabled: false,
    },
  },
  {
    y: 127.068,
    marker: {
      enabled: false,
    },
  },
  {
    y: 126.522,
    marker: {
      enabled: false,
    },
  },
  {
    y: 123.964,
    marker: {
      enabled: false,
    },
  },
  {
    y: 127.17,
    marker: {
      enabled: false,
    },
  },
  {
    y: 127.746,
    marker: {
      enabled: false,
    },
  },
  {
    y: 132.489,
    marker: {
      enabled: false,
    },
  },
  {
    y: 135.076,
    marker: {
      enabled: false,
    },
  },
  {
    y: 124.639,
    marker: {
      enabled: false,
    },
  },
  {
    y: 128.077,
    marker: {
      enabled: false,
    },
  },
  {
    y: 131.101,
    marker: {
      enabled: false,
    },
  },
  {
    y: 138.591,
    marker: {
      enabled: false,
    },
  },
  {
    y: 138.248,
    marker: {
      enabled: false,
    },
  },
  {
    y: 122.959,
    marker: {
      enabled: false,
    },
  },
  {
    y: 130.581,
    marker: {
      enabled: false,
    },
  },
  {
    y: 136.573,
    marker: {
      enabled: false,
    },
  },
  {
    y: 142.683,
    marker: {
      enabled: false,
    },
  },
  {
    y: 146.628,
    marker: {
      enabled: false,
    },
  },
  {
    y: 149.054,
    marker: {
      enabled: false,
    },
  },
  {
    y: 153.086,
    marker: {
      enabled: false,
    },
  },
  {
    y: 157.102,
    marker: {
      enabled: false,
    },
  },
  {
    y: 163.233,
    marker: {
      enabled: false,
    },
  },
  {
    y: 159.228,
    marker: {
      enabled: false,
    },
  },
  {
    y: 154.155,
    marker: {
      enabled: false,
    },
  },
  {
    y: 154.165,
    marker: {
      enabled: false,
    },
  },
  {
    y: 159.204,
    marker: {
      enabled: false,
    },
  },
  {
    y: 158.838,
    marker: {
      enabled: false,
    },
  },
  {
    y: 155.298,
    marker: {
      enabled: false,
    },
  },
  {
    y: 154.584,
    marker: {
      enabled: false,
    },
  },
  {
    y: 151.506,
    marker: {
      enabled: false,
    },
  },
  {
    y: 148.096,
    marker: {
      enabled: false,
    },
  },
  {
    y: 136.528,
    marker: {
      enabled: false,
    },
  },
  {
    y: 140.274,
    marker: {
      enabled: false,
    },
  },
  {
    y: 150.253,
    marker: {
      enabled: false,
    },
  },
  {
    y: 146.62,
    marker: {
      enabled: false,
    },
  },
  {
    y: 144.023,
    marker: {
      enabled: false,
    },
  },
  {
    y: 134.865,
    marker: {
      enabled: false,
    },
  },
  {
    y: 130.746,
    marker: {
      enabled: false,
    },
  },
  {
    y: 136.721,
    marker: {
      enabled: false,
    },
  },
  {
    y: 132.831,
    marker: {
      enabled: false,
    },
  },
  {
    y: 126.395,
    marker: {
      enabled: false,
    },
  },
  {
    y: 124.336,
    marker: {
      enabled: false,
    },
  },
  {
    y: 132.927,
    marker: {
      enabled: false,
    },
  },
  {
    y: 133.113,
    marker: {
      enabled: false,
    },
  },
  {
    y: 141.829,
    marker: {
      enabled: false,
    },
  },
  {
    y: 148.919,
    marker: {
      enabled: false,
    },
  },
  {
    y: 155.156,
    marker: {
      enabled: false,
    },
  },
  {
    y: 158.034,
    marker: {
      enabled: false,
    },
  },
  {
    y: 160.914,
    marker: {
      enabled: false,
    },
  },
  {
    y: 166.139,
    marker: {
      enabled: false,
    },
  },
  {
    y: 177.561,
    marker: {
      enabled: false,
    },
  },
  {
    y: 175.383,
    marker: {
      enabled: false,
    },
  },
  {
    y: 180.452,
    marker: {
      enabled: false,
    },
  },
  {
    y: 176.796,
    marker: {
      enabled: false,
    },
  },
  {
    y: 177.312,
    marker: {
      enabled: false,
    },
  },
  {
    y: 180.467,
    marker: {
      enabled: false,
    },
  },
  {
    y: 177.908,
    marker: {
      enabled: false,
    },
  },
  {
    y: 182.061,
    marker: {
      enabled: false,
    },
  },
  {
    y: 183.952,
    marker: {
      enabled: false,
    },
  },
  {
    y: 185.039,
    marker: {
      enabled: false,
    },
  },
  {
    y: 181.537,
    marker: {
      enabled: false,
    },
  },
  {
    y: 189.609,
    marker: {
      enabled: false,
    },
  },
  {
    y: 188.45,
    marker: {
      enabled: false,
    },
  },
  {
    y: 173.852,
    marker: {
      enabled: false,
    },
  },
  {
    y: 174.884,
    marker: {
      enabled: false,
    },
  },
  {
    y: 168.266,
    marker: {
      enabled: false,
    },
  },
  {
    y: 184.682,
    marker: {
      enabled: false,
    },
  },
  {
    y: 183.518,
    marker: {
      enabled: false,
    },
  },
  {
    y: 185.009,
    marker: {
      enabled: false,
    },
  },
  {
    y: 183.845,
    marker: {
      enabled: false,
    },
  },
  {
    y: 187.205,
    marker: {
      enabled: false,
    },
  },
  {
    y: 197.057,
    marker: {
      enabled: false,
    },
  },
  {
    y: 196.964,
    marker: {
      enabled: false,
    },
  },
  {
    y: 203.303,
    marker: {
      enabled: false,
    },
  },
  {
    y: 202.242,
    marker: {
      enabled: false,
    },
  },
  {
    y: 212.126,
    marker: {
      enabled: false,
    },
  },
  {
    y: 215.397,
    marker: {
      enabled: false,
    },
  },
  {
    y: 219.314,
    marker: {
      enabled: false,
    },
  },
  {
    y: 220.587,
    marker: {
      enabled: false,
    },
  },
  {
    y: 221.702,
    marker: {
      enabled: false,
    },
  },
  {
    y: 233.095,
    marker: {
      enabled: false,
    },
  },
  {
    y: 245.573,
    marker: {
      enabled: false,
    },
  },
  {
    y: 256.514,
    marker: {
      enabled: false,
    },
  },
  {
    y: 259.748,
    marker: {
      enabled: false,
    },
  },
  {
    y: 282.575,
    marker: {
      enabled: false,
    },
  },
  {
    y: 309.601,
    marker: {
      enabled: false,
    },
  },
  {
    y: 317.502,
    marker: {
      enabled: false,
    },
  },
  {
    y: 315.983,
    marker: {
      enabled: false,
    },
  },
  {
    y: 328.041,
    marker: {
      enabled: false,
    },
  },
  {
    y: 330.052,
    marker: {
      enabled: false,
    },
  },
  {
    y: 358.26,
    marker: {
      enabled: false,
    },
  },
  {
    y: 343.351,
    marker: {
      enabled: false,
    },
  },
  {
    y: 336.821,
    marker: {
      enabled: false,
    },
  },
  {
    y: 350.458,
    marker: {
      enabled: false,
    },
  },
  {
    y: 356.825,
    marker: {
      enabled: false,
    },
  },
  {
    y: 398.106,
    marker: {
      enabled: false,
    },
  },
  {
    y: 410.589,
    marker: {
      enabled: false,
    },
  },
  {
    y: 435.354,
    marker: {
      enabled: false,
    },
  },
  {
    y: 460.209,
    marker: {
      enabled: false,
    },
  },
  {
    y: 460.177,
    marker: {
      enabled: false,
    },
  },
  {
    y: 459.236,
    marker: {
      enabled: false,
    },
  },
  {
    y: 467.738,
    marker: {
      enabled: false,
    },
  },
  {
    y: 494.701,
    marker: {
      enabled: false,
    },
  },
  {
    y: 485.4,
    marker: {
      enabled: false,
    },
  },
  {
    y: 402.279,
    marker: {
      enabled: false,
    },
  },
  {
    y: 391.765,
    marker: {
      enabled: false,
    },
  },
  {
    y: 407.994,
    marker: {
      enabled: false,
    },
  },
  {
    y: 417.213,
    marker: {
      enabled: false,
    },
  },
  {
    y: 440.683,
    marker: {
      enabled: false,
    },
  },
  {
    y: 453.227,
    marker: {
      enabled: false,
    },
  },
  {
    y: 458.164,
    marker: {
      enabled: false,
    },
  },
  {
    y: 448.228,
    marker: {
      enabled: false,
    },
  },
  {
    y: 446.842,
    marker: {
      enabled: false,
    },
  },
  {
    y: 454.478,
    marker: {
      enabled: false,
    },
  },
  {
    y: 428.746,
    marker: {
      enabled: false,
    },
  },
  {
    y: 446.168,
    marker: {
      enabled: false,
    },
  },
  {
    y: 475.074,
    marker: {
      enabled: false,
    },
  },
  {
    y: 490.802,
    marker: {
      enabled: false,
    },
  },
  {
    y: 494.428,
    marker: {
      enabled: false,
    },
  },
  {
    y: 511.511,
    marker: {
      enabled: false,
    },
  },
  {
    y: 507.484,
    marker: {
      enabled: false,
    },
  },
  {
    y: 503.406,
    marker: {
      enabled: false,
    },
  },
  {
    y: 514.189,
    marker: {
      enabled: false,
    },
  },
  {
    y: 500.763,
    marker: {
      enabled: false,
    },
  },
  {
    y: 494.288,
    marker: {
      enabled: false,
    },
  },
  {
    y: 549.295,
    marker: {
      enabled: false,
    },
  },
  {
    y: 535.165,
    marker: {
      enabled: false,
    },
  },
  {
    y: 549.417,
    marker: {
      enabled: false,
    },
  },
  {
    y: 530.233,
    marker: {
      enabled: false,
    },
  },
  {
    y: 550.528,
    marker: {
      enabled: false,
    },
  },
  {
    y: 567.338,
    marker: {
      enabled: false,
    },
  },
  {
    y: 539.944,
    marker: {
      enabled: false,
    },
  },
  {
    y: 515.886,
    marker: {
      enabled: false,
    },
  },
  {
    y: 483.818,
    marker: {
      enabled: false,
    },
  },
  {
    y: 475.922,
    marker: {
      enabled: false,
    },
  },
  {
    y: 525.101,
    marker: {
      enabled: false,
    },
  },
  {
    y: 520.408,
    marker: {
      enabled: false,
    },
  },
  {
    y: 524.178,
    marker: {
      enabled: false,
    },
  },
  {
    y: 474.129,
    marker: {
      enabled: false,
    },
  },
  {
    y: 423.145,
    marker: {
      enabled: false,
    },
  },
  {
    y: 461.64,
    marker: {
      enabled: false,
    },
  },
  {
    y: 453.05,
    marker: {
      enabled: false,
    },
  },
  {
    y: 461.527,
    marker: {
      enabled: false,
    },
  },
  {
    y: 477.387,
    marker: {
      enabled: false,
    },
  },
  {
    y: 520.574,
    marker: {
      enabled: false,
    },
  },
  {
    y: 504.264,
    marker: {
      enabled: false,
    },
  },
  {
    y: 507.243,
    marker: {
      enabled: false,
    },
  },
  {
    y: 517.764,
    marker: {
      enabled: false,
    },
  },
  {
    y: 484.846,
    marker: {
      enabled: false,
    },
  },
  {
    y: 506.778,
    marker: {
      enabled: false,
    },
  },
  {
    y: 504.198,
    marker: {
      enabled: false,
    },
  },
  {
    y: 516.432,
    marker: {
      enabled: false,
    },
  },
  {
    y: 523.818,
    marker: {
      enabled: false,
    },
  },
  {
    y: 499.994,
    marker: {
      enabled: false,
    },
  },
  {
    y: 535.364,
    marker: {
      enabled: false,
    },
  },
  {
    y: 524.448,
    marker: {
      enabled: false,
    },
  },
  {
    y: 514.402,
    marker: {
      enabled: false,
    },
  },
  {
    y: 489.176,
    marker: {
      enabled: false,
    },
  },
  {
    y: 494.993,
    marker: {
      enabled: false,
    },
  },
  {
    y: 513.665,
    marker: {
      enabled: false,
    },
  },
  {
    y: 495.424,
    marker: {
      enabled: false,
    },
  },
  {
    y: 495.645,
    marker: {
      enabled: false,
    },
  },
  {
    y: 506.637,
    marker: {
      enabled: false,
    },
  },
  {
    y: 500.953,
    marker: {
      enabled: false,
    },
  },
  {
    y: 486.384,
    marker: {
      enabled: false,
    },
  },
  {
    y: 494.113,
    marker: {
      enabled: false,
    },
  },
  {
    y: 497.132,
    marker: {
      enabled: false,
    },
  },
  {
    y: 497.833,
    marker: {
      enabled: false,
    },
  },
  {
    y: 508.673,
    marker: {
      enabled: false,
    },
  },
  {
    y: 537.2,
    marker: {
      enabled: false,
    },
  },
  {
    y: 561.116,
    marker: {
      enabled: false,
    },
  },
  {
    y: 573.068,
    marker: {
      enabled: false,
    },
  },
  {
    y: 567.291,
    marker: {
      enabled: false,
    },
  },
  {
    y: 578.019,
    marker: {
      enabled: false,
    },
  },
  {
    y: 603.556,
    marker: {
      enabled: false,
    },
  },
  {
    y: 591.436,
    marker: {
      enabled: false,
    },
  },
  {
    y: 606.772,
    marker: {
      enabled: false,
    },
  },
  {
    y: 571.488,
    marker: {
      enabled: false,
    },
  },
  {
    y: 598.496,
    marker: {
      enabled: false,
    },
  },
  {
    y: 637.008,
    marker: {
      enabled: false,
    },
  },
  {
    y: 627.79,
    marker: {
      enabled: false,
    },
  },
  {
    y: 599.737,
    marker: {
      enabled: false,
    },
  },
  {
    y: 617.299,
    marker: {
      enabled: false,
    },
  },
  {
    y: 617.906,
    marker: {
      enabled: false,
    },
  },
  {
    y: 615.194,
    marker: {
      enabled: false,
    },
  },
  {
    y: 625.894,
    marker: {
      enabled: false,
    },
  },
  {
    y: 643.738,
    marker: {
      enabled: false,
    },
  },
  {
    y: 625.806,
    marker: {
      enabled: false,
    },
  },
  {
    y: 642.57,
    marker: {
      enabled: false,
    },
  },
  {
    y: 613.676,
    marker: {
      enabled: false,
    },
  },
  {
    y: 618.59,
    marker: {
      enabled: false,
    },
  },
  {
    y: 608.263,
    marker: {
      enabled: false,
    },
  },
  {
    y: 616.074,
    marker: {
      enabled: false,
    },
  },
  {
    y: 644.674,
    marker: {
      enabled: false,
    },
  },
  {
    y: 666.043,
    marker: {
      enabled: false,
    },
  },
  {
    y: 670.635,
    marker: {
      enabled: false,
    },
  },
  {
    y: 669.317,
    marker: {
      enabled: false,
    },
  },
  {
    y: 701.687,
    marker: {
      enabled: false,
    },
  },
  {
    y: 684.957,
    marker: {
      enabled: false,
    },
  },
  {
    y: 703.797,
    marker: {
      enabled: false,
    },
  },
  {
    y: 691.604,
    marker: {
      enabled: false,
    },
  },
  {
    y: 714.509,
    marker: {
      enabled: false,
    },
  },
  {
    y: 734.28,
    marker: {
      enabled: false,
    },
  },
  {
    y: 746.451,
    marker: {
      enabled: false,
    },
  },
  {
    y: 749.857,
    marker: {
      enabled: false,
    },
  },
  {
    y: 761.184,
    marker: {
      enabled: false,
    },
  },
  {
    y: 777.929,
    marker: {
      enabled: false,
    },
  },
  {
    y: 777.437,
    marker: {
      enabled: false,
    },
  },
  {
    y: 780.202,
    marker: {
      enabled: false,
    },
  },
  {
    y: 751.451,
    marker: {
      enabled: false,
    },
  },
  {
    y: 758.902,
    marker: {
      enabled: false,
    },
  },
  {
    y: 787.436,
    marker: {
      enabled: false,
    },
  },
  {
    y: 791.751,
    marker: {
      enabled: false,
    },
  },
  {
    y: 834.929,
    marker: {
      enabled: false,
    },
  },
  {
    y: 820.362,
    marker: {
      enabled: false,
    },
  },
  {
    y: 829.082,
    marker: {
      enabled: false,
    },
  },
  {
    y: 837.44,
    marker: {
      enabled: false,
    },
  },
  {
    y: 819.678,
    marker: {
      enabled: false,
    },
  },
  {
    y: 845.281,
    marker: {
      enabled: false,
    },
  },
  {
    y: 896.244,
    marker: {
      enabled: false,
    },
  },
  {
    y: 939.746,
    marker: {
      enabled: false,
    },
  },
  {
    y: 981.845,
    marker: {
      enabled: false,
    },
  },
  {
    y: 914.974,
    marker: {
      enabled: false,
    },
  },
  {
    y: 963.489,
    marker: {
      enabled: false,
    },
  },
  {
    y: 911.569,
    marker: {
      enabled: false,
    },
  },
  {
    y: 926.496,
    marker: {
      enabled: false,
    },
  },
  {
    y: 936.591,
    marker: {
      enabled: false,
    },
  },
  {
    y: 961.488,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1025.297,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1067.354,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1076.53,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1061.791,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1085.737,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1082.741,
    marker: {
      enabled: false,
    },
  },
  {
    y: 937.092,
    marker: {
      enabled: false,
    },
  },
  {
    y: 952.393,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1037.208,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1097.621,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1149.952,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1173.844,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1141.327,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1187.545,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1233.057,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1186.701,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1240.75,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1235.701,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1232.161,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1218.897,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1280.942,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1315.675,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1420.885,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1338.246,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1340.583,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1431.938,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1370.108,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1334.136,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1377.722,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1337.647,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1379.87,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1305.245,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1282.138,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1203.054,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1221.253,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1244.222,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1137.879,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1061.262,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1138.087,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1121.088,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1084.788,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1069.669,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1016.732,
    marker: {
      enabled: false,
    },
  },
  {
    y: 926.023,
    marker: {
      enabled: false,
    },
  },
  {
    y: 943.2,
    marker: {
      enabled: false,
    },
  },
  {
    y: 997.928,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1003.516,
    marker: {
      enabled: false,
    },
  },
  {
    y: 972.418,
    marker: {
      enabled: false,
    },
  },
  {
    y: 962.732,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1003.597,
    marker: {
      enabled: false,
    },
  },
  {
    y: 968.25,
    marker: {
      enabled: false,
    },
  },
  {
    y: 967.847,
    marker: {
      enabled: false,
    },
  },
  {
    y: 907.81,
    marker: {
      enabled: false,
    },
  },
  {
    y: 830.549,
    marker: {
      enabled: false,
    },
  },
  {
    y: 830.582,
    marker: {
      enabled: false,
    },
  },
  {
    y: 738.179,
    marker: {
      enabled: false,
    },
  },
  {
    y: 791.883,
    marker: {
      enabled: false,
    },
  },
  {
    y: 833.471,
    marker: {
      enabled: false,
    },
  },
  {
    y: 792.215,
    marker: {
      enabled: false,
    },
  },
  {
    y: 767.478,
    marker: {
      enabled: false,
    },
  },
  {
    y: 752.864,
    marker: {
      enabled: false,
    },
  },
  {
    y: 748.628,
    marker: {
      enabled: false,
    },
  },
  {
    y: 813.302,
    marker: {
      enabled: false,
    },
  },
  {
    y: 857.649,
    marker: {
      enabled: false,
    },
  },
  {
    y: 871.066,
    marker: {
      enabled: false,
    },
  },
  {
    y: 887.78,
    marker: {
      enabled: false,
    },
  },
  {
    y: 905.324,
    marker: {
      enabled: false,
    },
  },
  {
    y: 909.641,
    marker: {
      enabled: false,
    },
  },
  {
    y: 962.707,
    marker: {
      enabled: false,
    },
  },
  {
    y: 976.019,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1036.318,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1052.289,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1068.648,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1059.157,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1035.657,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1042.626,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1062.514,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1026.991,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1029.631,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1047.861,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1072.698,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1127.339,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1169.341,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1142.35,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1176.703,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1151.184,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1123.642,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1140.677,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1148.813,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1188.165,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1194.807,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1224.314,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1193.88,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1231.412,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1257.775,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1313.214,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1309.451,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1335.069,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1373.384,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1322.246,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1319.934,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1327.233,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1358.872,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1373.368,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1422.926,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1455.166,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1483.578,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1500.232,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1490.44,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1514.181,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1577.86,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1616.871,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1602.36,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1565.811,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1561.585,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1633.576,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1682.351,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1610.942,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1588.803,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1466.346,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1455.56,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1437.403,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1508.988,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1525.726,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1402.129,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1366.699,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1344.862,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1182.443,
    marker: {
      enabled: false,
    },
  },
  {
    y: 957.245,
    marker: {
      enabled: false,
    },
  },
  {
    y: 892.926,
    marker: {
      enabled: false,
    },
  },
  {
    y: 920.226,
    marker: {
      enabled: false,
    },
  },
  {
    y: 838.827,
    marker: {
      enabled: false,
    },
  },
  {
    y: 750.863,
    marker: {
      enabled: false,
    },
  },
  {
    y: 805.216,
    marker: {
      enabled: false,
    },
  },
  {
    y: 893.025,
    marker: {
      enabled: false,
    },
  },
  {
    y: 970.004,
    marker: {
      enabled: false,
    },
  },
  {
    y: 964.048,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1044.753,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1085.599,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1126.985,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1106.17,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1149.007,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1168.468,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1119.537,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1133.348,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1200.53,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1198.564,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1079.801,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1041.323,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1124.826,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1080.699,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1179.194,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1222.226,
    marker: {
      enabled: true,
    },
  },
  {
    y: 1193.558,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1280.071,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1308.083,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1351.647,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1334.925,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1388.62,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1354.607,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1331.182,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1306.054,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1211.224,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1104.065,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1217.296,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1184.604,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1182.595,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1240.894,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1298.72,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1312.011,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1293.991,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1177.645,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1235.716,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1250.569,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1279.208,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1311.504,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1301.522,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1315.493,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1338.5,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1405.466,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1405.18,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1434.515,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1476.139,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1471.933,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1433.548,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1507.913,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1472.738,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1543.672,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1602.86,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1628.424,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1661.069,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1598.456,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1675.4,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1673.874,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1687.742,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1715.184,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1743.415,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1714.353,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1748.688,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1698.408,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1708.092,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1739.497,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1709.672,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1677.537,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1772.862,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1740.814,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1778.4,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1779.307,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1735.613,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1765.604,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1645.43,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1581.922,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1705.803,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1694.397,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1662.794,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1562.178,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1547.174,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1648.118,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1670.796,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1674.613,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1653.229,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1721.788,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1719.524,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1725.665,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1690.922,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1712.089,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1751.219,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1792.403,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1838.699,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1853.69,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1878.276,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1911.74,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1916.426,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1961.1,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1959.743,
    marker: {
      enabled: false,
    },
  },
  {
    y: 2000.553,
    marker: {
      enabled: false,
    },
  },
  {
    y: 2036.804,
    marker: {
      enabled: false,
    },
  },
  {
    y: 2077.36,
    marker: {
      enabled: false,
    },
  },
  {
    y: 2103.448,
    marker: {
      enabled: false,
    },
  },
  {
    y: 2213.238,
    marker: {
      enabled: false,
    },
  },
  {
    y: 2117.993,
    marker: {
      enabled: false,
    },
  },
  {
    y: 2066.845,
    marker: {
      enabled: false,
    },
  },
  {
    y: 2086.514,
    marker: {
      enabled: false,
    },
  },
  {
    y: 2092.923,
    marker: {
      enabled: false,
    },
  },
  {
    y: 2089.301,
    marker: {
      enabled: false,
    },
  },
  {
    y: 2153.096,
    marker: {
      enabled: false,
    },
  },
  {
    y: 2175.498,
    marker: {
      enabled: false,
    },
  },
  {
    y: 2184.009,
    marker: {
      enabled: false,
    },
  },
  {
    y: 2021.982,
    marker: {
      enabled: false,
    },
  },
  {
    y: 2041.359,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1883.901,
    marker: {
      enabled: false,
    },
  },
  {
    y: 2028.492,
    marker: {
      enabled: false,
    },
  },
  {
    y: 2085.845,
    marker: {
      enabled: false,
    },
  },
  {
    y: 2107.742,
    marker: {
      enabled: false,
    },
  },
  {
    y: 2178.674,
    marker: {
      enabled: false,
    },
  },
  {
    y: 2046.246,
    marker: {
      enabled: false,
    },
  },
  {
    y: 2178.347,
    marker: {
      enabled: false,
    },
  },
  {
    y: 2187.564,
    marker: {
      enabled: false,
    },
  },
  {
    y: 2138.521,
    marker: {
      enabled: false,
    },
  },
  {
    y: 2180.018,
    marker: {
      enabled: false,
    },
  },
  {
    y: 2233.526,
    marker: {
      enabled: false,
    },
  },
  {
    y: 2292.259,
    marker: {
      enabled: false,
    },
  },
  {
    y: 2358.468,
    marker: {
      enabled: false,
    },
  },
  {
    y: 2342.414,
    marker: {
      enabled: false,
    },
  },
  {
    y: 2141.124,
    marker: {
      enabled: false,
    },
  },
  {
    y: 1852.727,
    marker: {
      enabled: false,
    },
  },
  {
    y: 2052.845,
    marker: {
      enabled: false,
    },
  },
  {
    y: 2147.882,
    marker: {
      enabled: false,
    },
  },
  {
    y: 2201.788,
    marker: {
      enabled: false,
    },
  },
  {
    y: 2304.982,
    marker: {
      enabled: false,
    },
  },
  {
    y: 2455.512,
    marker: {
      enabled: false,
    },
  },
  {
    y: 2367.27,
    marker: {
      enabled: false,
    },
  },
  {
    y: 2292.925,
    marker: {
      enabled: false,
    },
  },
  {
    y: 2583.143,
    marker: {
      enabled: false,
    },
  },
  {
    y: 2690.044,
    marker: {
      enabled: false,
    },
  },
  {
    y: 2661.691,
    marker: {
      enabled: false,
    },
  },
  {
    y: 2726.91,
    marker: {
      enabled: false,
    },
  },
  {
    y: 2811.699,
    marker: {
      enabled: false,
    },
  },
  {
    y: 2938.764,
    marker: {
      enabled: false,
    },
  },
  {
    y: 2975.701,
    marker: {
      enabled: false,
    },
  },
  {
    y: 3017.222,
    marker: {
      enabled: false,
    },
  },
  {
    y: 3069.249,
    marker: {
      enabled: false,
    },
  },
  {
    y: 3141.351,
    marker: {
      enabled: false,
    },
  },
  {
    y: 3006.604,
    marker: {
      enabled: false,
    },
  },
  {
    y: 3174.725,
    marker: {
      enabled: false,
    },
  },
  {
    y: 3101.796,
    marker: {
      enabled: false,
    },
  },
  {
    y: 3231.727,
    marker: {
      enabled: false,
    },
  },
  {
    y: 3059.047,
    marker: {
      enabled: false,
    },
  },
  {
    y: 2977.954,
    marker: {
      enabled: false,
    },
  },
  {
    y: 3053.07,
    marker: {
      enabled: false,
    },
  },
  {
    y: 2795.615,
    marker: {
      enabled: false,
    },
  },
  {
    y: 2791.013,
    marker: {
      enabled: false,
    },
  },
  {
    y: 2546.185,
    marker: {
      enabled: false,
    },
  },
  {
    y: 2746.365,
    marker: {
      enabled: false,
    },
  },
  {
    y: 2627.321,
    marker: {
      enabled: false,
    },
  },
  {
    y: 2378.645,
    marker: {
      enabled: false,
    },
  },
  {
    y: 2547.716,
    marker: {
      enabled: false,
    },
  },
  {
    y: 2720.889,
    marker: {
      enabled: false,
    },
  },
  {
    y: 2602.685,
    marker: {
      enabled: false,
    },
  },
  {
    y: 2784.995,
    marker: {
      enabled: false,
    },
  },
  {
    y: 2714.571,
    marker: {
      enabled: false,
    },
  },
  {
    y: 2791.438,
    marker: {
      enabled: false,
    },
  },
  {
    y: 2835.928,
    marker: {
      enabled: false,
    },
  },
  {
    y: 2800.557,
    marker: {
      enabled: false,
    },
  },
  {
    y: 2966.724,
    marker: {
      enabled: false,
    },
  },
  {
    y: 3064.297,
    marker: {
      enabled: false,
    },
  },
  {
    y: 2986.023,
    marker: {
      enabled: false,
    },
  },
  {
    y: 2853.235,
    marker: {
      enabled: false,
    },
  },
  {
    y: 2768.621,
    marker: {
      enabled: false,
    },
  },
  {
    y: 3023.63,
    marker: {
      enabled: false,
    },
  },
  {
    y: 3169.18,
    marker: {
      enabled: false,
    },
  },
  {
    y: 3205.317,
    marker: {
      enabled: false,
    },
  },
  {
    y: 3337.204,
    marker: {
      enabled: false,
    },
  },
  {
    y: 3437.76,
    marker: {
      enabled: false,
    },
  },
  {
    y: 3305.296,
    marker: {
      enabled: false,
    },
  },
  {
    y: 3445.172,
    marker: {
      enabled: false,
    },
  },
];
